import {ProcessDatePicker} from "components";

import {useFormContext, Controller} from "react-hook-form";
import {Process} from "views/ProcessDetails/refactor/types/process.types";

type Props = {
  index: number;
  disabled: boolean;
};

const VoyageGrantDateField = (props: Props) => {
  const {index, disabled} = props;
  const {control} = useFormContext<Process>();

  return (
    <Controller
      name={
        `boarding.voyages.${index}.grantDate` as `boarding.voyages.0.grantDate`
      }
      control={control}
      render={({field: {value}}) => (
        <ProcessDatePicker
          value={value}
          name={`boarding.voyages.${index}.grantDate`}
          errorName="Grant Date"
          title={`Concessão DTA viagem ${index + 1}`}
          disabled={disabled}
          fullWidth
          label="Concessão DTA"
        />
      )}
    />
  );
};

export default VoyageGrantDateField;
